export const ALERT_AUTO_DISMISS_TIMING_MS = 5000;